import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@frontend/shadcn/components/ui/sheet';

interface FilterSheetProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
  onCancel?: () => void;
  onApply?: () => void;
  cancelDataAttribute?: string;
  applyDataAttribute?: string;
  applyButtonText?: string;
  cancelButtonText?: string;
}

export const FilterSheet: React.FC<FilterSheetProps> = ({
  isOpen,
  onOpenChange,
  title,
  children,
  onCancel: _onCancel,
  onApply: _onApply,
  cancelDataAttribute: _cancelDataAttribute,
  applyDataAttribute: _applyDataAttribute,
  applyButtonText: _applyButtonText,
  cancelButtonText: _cancelButtonText,
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange} aria-expanded={isOpen}>
      <SheetContent>
        <SheetHeader className="flex justify-start gap-2 px-6 mt-auto border-b bg-background mx-[-1.5rem]">
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        {children}
      </SheetContent>
    </Sheet>
  );
};
